import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'
import Paper from 'material-ui/Paper'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import Avatar from 'material-ui/Avatar'

import JobCard from '../common/JobCard'
import ScheduleUtils from '../common/ScheduleUtils'
import './UserPreview.css'

import { startCalendarSync, stopCalendarSync } from 'infra/actions/calendars'

class UserPreview extends React.Component {

  static propTypes = {
    userInfo: PropTypes.object.isRequired,
    teamId: PropTypes.string.isRequired,
    dateStr: PropTypes.string.isRequired,
    instances: PropTypes.array,
    calendarEvents: PropTypes.object,
    calendarDisplay: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      reportInfo: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dateStr !== this.props.dateStr) {
      this.detachLoaders(this.props.dateStr)

      this.setState({
        reportInfo: false,
        dateStr: nextProps.dateStr
      })

      this.initLoaders(nextProps.dateStr)
    }
  }

  componentWillMount() {
    this.initLoaders(this.props.dateStr)
  }

  componentWillUnmount() {
    this.detachLoaders(this.props.dateStr)
  }

  getCalendarId() {
    const userId = this.props.userInfo.userId
    return `${userId}@${this.props.teamId}`
  }

  initLoaders(dateStr) {
    const calendarId = this.getCalendarId()
    this.props.dispatch(startCalendarSync(calendarId, dateStr))
    firebase.database().ref(`timesheets/${calendarId}/${dateStr}/info`)
      .on('value', this.onTimesheetValue)
  }

  detachLoaders(dateStr) {
    const calendarId = this.getCalendarId()
    this.props.dispatch(stopCalendarSync(calendarId, dateStr))
    firebase.database().ref(`timesheets/${calendarId}/${dateStr}/info`)
      .off('value', this.onTimesheetValue)
  }

  onTimesheetValue = (snapshot) => {
    let value = snapshot && snapshot.val() || {}
    this.setState({ reportInfo: value })
  }

  renderJobs() {
    if (!this.props.instances) {
      return <CircularProgress style={{ margin: 60 }} thickness={2} />
    }
    const sortedInstances = ScheduleUtils.getSortedInstancesIds(this.props.instances,
      this.props.calendarEvents, this.props.calendarDisplay, this.getCalendarId(), this.props.dateStr)
    return sortedInstances.map(instanceId => 
      <JobCard
        style={{ marginTop: 6, height: 64, width: 178 }}
        key={instanceId}
        eventId={instanceId}
        dateStr={this.props.dateStr}
        userId={this.props.userInfo.userId} />
    )
  }

  handle
  render() {
    let hours = 'Loading'
    if (!this.state.reportInfo.modules) {
      hours = ''
    } else {
      const clockingDay = this.state.reportInfo.modules.clockingDay
      hours =
        (clockingDay.timeIn ? clockingDay.timeIn : '')
        + ' - ' +
        (clockingDay.timeOut ? clockingDay.timeOut : '')
    }
    return (
      <Paper className="UserPreview">
        <div className="UserPreview-header">
          <div>
            <Avatar
              size={33}
              backgroundColor={this.props.userInfo.color}>
              {this.props.userInfo.displayName.substring(0, 1)}
            </Avatar>
          </div>
          <div
            style={{ display: 'flex', flexDirection: 'column',
              marginLeft: 5, marginTop: 5, alignItems: 'flex-start'}}>
            <span className="User-name">
              { this.props.userInfo.displayName }
            </span>
            <span className="User-hours">
              { hours }
            </span>
          </div>
        </div>

        { this.renderJobs() }

        <FlatButton
          ref={addJobButton => this.addJobButton = addJobButton}
          style={styles.addJobButton}
          labelStyle={{ color: 'rgba(0, 0, 0, 0.4)' }}
          onTouchTap={(event) => {
            event.preventDefault()
            this.props.dispatch({
              type: 'UI_DIALOG',
              label: 'ADD_JOB',
              value: {
                dateStr: this.props.dateStr,
                workerId: this.props.userInfo.userId,
                anchorButton: this.addJobButton
              }
            })
          }}>
          +
        </FlatButton>
      </Paper>
    )
  }
}

const styles = {
  addJobButton: {
    height: 32,
    width: 32,
    minWidth: 32,
    margin: 8,
    borderRadius: 16,
    lineHeight: undefined,
    color: '#455559',
    border: 'solid 1px #bdbdbd'
  }
}

function mapStateToProps(state, ownProps) {
  const userId = ownProps.userInfo.userId
  const teamId = state.firebase.team.metadata.value.id
  const combinedId = `${userId}@${teamId}->${ownProps.dateStr}`
  return {
    instances: state.schedule.instances[combinedId],
    calendarEvents: state.firebase.calendarEvents,
    calendarDisplay: state.firebase.calendarDisplay,
    teamId
  }
}

export default connect(mapStateToProps)(UserPreview)



// WEBPACK FOOTER //
// ./src/schedule/day/UserPreview.js